import Typography from 'components/shared/Typography/Typography';

const RequiredDisclosure = () => (
  <div className="mx-auto w-full px-6 pb-8 pt-4">
    <div className="rounded-md border border-solid border-neutral-200 bg-white px-4 py-3">
      <Typography
        variant="p"
        size="small"
        weight="semibold"
        className="mb-2 uppercase tracking-wider text-neutral-500">
        Required Disclosures & Patient Rights
      </Typography>
      <ul className="m-0 mb-2 pl-4 text-left">
        <li className="break-words text-sm font-normal leading-5 text-neutral-900">
          This is a Good Faith Estimate (GFE), not a bill. Final charges may vary. For recurring
          care, this GFE is valid for no longer than 12 months. A new GFE is issued at each visit.
        </li>
        <li className="break-words text-sm font-normal leading-5 text-neutral-900">
          If you&apos;re uninsured or self-pay, you may dispute charges $400+ over this estimate at
          www.cms.gov/nosurprises or 1-800-985-3059.
        </li>
      </ul>
      <Typography variant="p" size="small" className="leading-5 text-neutral-900">
        The attached invoice includes the expected services and associated costs for this visit.
        Items marked &ldquo;Separate Scheduling Required&rdquo; may require a separate Good Faith
        Estimate. You may request one by contacting our practice directly. This Good Faith Estimate
        is provided pursuant to the No Surprises Act (§300gg-136).
      </Typography>
      <Typography variant="p" size="small" className="mt-2 leading-5 text-neutral-900">
        Changes in insurance status, deductible information, payer processing, or additional
        services provided will impact your final balance. Our practice is committed to compliance,
        clarity, and care.
      </Typography>
    </div>
  </div>
);

export default RequiredDisclosure;
